import { browserCheck } from '@ta-interaktiv/browsercheck'

const cityDistricts = require('../_assets/stzh.adm_stadtkreise_v.json')

export const labelLayer: mapboxgl.Layer = {
  id: 'labels',
  type: 'symbol',
  source: 'restaurants_all',
  minzoom: 15,
  layout: {
    'text-field': ['get', 'rest'],
    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
    'text-size': 12,
    'text-radial-offset': 1.5
  }
}
export const mobileCircles: mapboxgl.Layer = {
  id: 'symbols',
  type: 'circle',
  source: 'restaurants_all',
  paint: {
    'circle-color': ['get', 'color'],
    'circle-radius': {
      stops: [
        [13, 6],
        [14, 6],
        [15, 10]
      ]
    }
  }
}

export const desktopCircles: mapboxgl.Layer = {
  id: 'symbols',
  type: 'symbol',
  source: 'restaurants_all',
  layout: {
    'icon-image': ['get', 'id'],
    'icon-size': 0.2,
    'icon-allow-overlap': true
  }
}

export const circleHalo: mapboxgl.Layer = {
  id: 'iconbg',
  type: 'circle',
  source: 'restaurants_all',
  paint: {
    'circle-color': ['get', 'color'],
    'circle-radius': browserCheck.isMobile
      ? {
          stops: [
            [13, 18],
            [14, 15],
            [15, 12]
          ]
        }
      : 12,
    'circle-opacity': 0.4
  }
}

export const districts: mapboxgl.Layer = {
  id: 'districts',
  type: 'fill',
  source: {
    type: 'geojson',
    data: cityDistricts
  },
  layout: {},
  paint: {
    'fill-color': 'rgba(0,0,0,0.0)',
    'fill-opacity': 0.8
  }
}
export const districtsLine: mapboxgl.Layer = {
  id: 'districtsLine',
  type: 'line',
  source: {
    type: 'geojson',
    data: cityDistricts
  },
  layout: {},
  paint: {
    'line-color': '#fff',
    'line-width': 2
  }
}
